import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUsers } from '../../../../api/UsersAPI';
import AppBreadCrumb from '../../../common/AppBreadCrumb';
import AppPaginator from '../../../AppPaginator';
import AppSearchBox from '../../../AppSearchBox';
import PerPageBlock from '../../../common/PerPageBlock';
import { getAvatar } from '../../../../commonfunctions';

const MembersPage = () => {
    const navigate = useNavigate();
    const [membersList, setMembersList] = useState({ data: [], last_page: 0 });
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCompleted, setSearchTermCompleted] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const filters = {
            paginate:true,
            page: currentPage,
            per_page: perPage,
            search_term: searchTermCompleted
        };
        getUsers(filters, (response) => {
            setIsLoading(false);
            if (response.users) {
                setMembersList(response.users);
            }
        });
    }, [currentPage, perPage, searchTermCompleted]);

    // --- NEW: Handler for viewing member statistics ---
    const handleViewStats = (memberId) => {
        navigate(`/club_portal/members/${memberId}`);
    };

    // --- NEW: Handler for viewing member ledger ---
    const handleViewLedger = (memberId) => {
        navigate(`/club_portal/financials/ledgers/${memberId}`);
    };

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Club Members" />
                <div className="row">
                    <div className="col-12">
                        <div className="tab-wrapper mb-3">
                            <ul className="tabs">
                                <li className="tab-link active">All Members</li>
                                <li className="ms-md-auto">
                                    <div className="text-md-end">
                                        <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted} />
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="content-wrapper">
                            <div className="d-flex m-md-3">
                                {membersList.data.length > 0 && (
                                    <>
                                        <AppPaginator totalPages={membersList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                                        <PerPageBlock perPage={perPage} setPerPage={setPerPage} />
                                    </>
                                )}
                                {isLoading && <div className="loader_box ms-auto"><div className="loader_14"></div></div>}
                            </div>
                            <div className="tabs-content active">
                                <div className="row">
                                    {!isLoading && (
                                        membersList.data.length > 0 ? membersList.data.map(member => {
                                            // --- NEW: Logic to determine balance and color ---
                                            const balance = member.current_wallet_balance ?? '0.00';
                                            const balanceColor = balance < 0 ? 'text-danger' : 'text-success';

                                            return (
                                                // --- The onClick handler on the parent div is removed ---
                                                <div className="col-md-6 col-xl-4 project-card" key={member.id}>
                                                    <div className="card hover-effect h-100">
                                                         <div className="card-body d-flex flex-column text-center">
                                                            {/* Image is now centered with mx-auto */}
                                                            <img 
                                                                alt={member.name} 
                                                                className="img-fluid rounded-circle mx-auto mb-2" 
                                                                src={getAvatar(member.profile_pic_path)} 
                                                                style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                                            />
                                                            
                                                            {/* Name and Phone are now centered by the parent's text-center class */}
                                                            <h6 className="m-0 text-dark f-w-600 txt-ellipsis-1">{member.name}</h6>
                                                            <small className="text-muted">{member.phone_number}</small>

                                                            <hr className="my-3" />
                                                            
                                                            {/* Balance display was already centered */}
                                                            <div>
                                                                <p className="m-0 text-muted">Current Balance</p>
                                                                <h4 className={`m-0 fw-bold ${balanceColor}`}>₹{Number(balance).toFixed(2)}</h4>
                                                            </div>

                                                            {/* Action buttons at the bottom */}
                                                            <div className="mt-auto pt-3">
                                                                <button className="btn btn-outline-primary btn-sm me-2" onClick={() => handleViewStats(member.id)}>View Stats</button>
                                                                <button className="btn btn-primary btn-sm" onClick={() => handleViewLedger(member.id)}>View Ledger</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }) : (
                                            <div className="card mb-3">
                                                {/* ... No members found content ... */}
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default MembersPage;